import React, { Component } from 'react'
import { Switch, Route, Redirect, Link } from 'react-router-dom'
import { connect } from 'react-redux';

import Aux from './AuxContainer'

import ArtistLoginContainer from './ArtistLoginContainer'
import ArtistRegisterContainer from './ArtistRegisterContainer'
import ArtistDashboardContainer from './ArtistDashboardContainer'
import ArtistProjectsContainer from './ArtistProjectsContainer'


class ArtistContainer extends Component {
	render() {
		const { match, artistToken } = this.props
		return (
			<Aux>
			  <Switch>
			    <Route path={`${match.path}/login`} exact component={ArtistLoginContainer} />
			    <Route path={`${match.path}/register`} exact component={ArtistRegisterContainer} />
			    <Route path={`${match.path}/dashboard`} exact component={ArtistDashboardContainer} />
			    <Route path={`${match.path}/dashboard/projects`} exact component={ArtistDashboardContainer} />
			    <Route path={`${match.path}/projects`} exact component={ArtistProjectsContainer} />
			    <Redirect to={`${match.path}/login`} />
			  </Switch>
		 	</Aux>

		)
	}
}


const mapStateToProps = state => ({
	artistToken: state.common.artistToken
})

const mapDispatchToProps = dispatch => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(ArtistContainer)


// WEBPACK FOOTER //
// ./src/containers/ArtistContainer.js